export const generateVacanciesLink = (regionId: number, name: string | undefined) =>
  `/vacancies-realtors/?regionid=${regionId}&companyname=${name ? encodeURIComponent(name) : ''}`;
